import Reload from './Reload';

export default {
  reload: Reload,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/Icon/Icons/index.jsx